import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CustomerInteractionRealTimeMessagePayload } from "../real-time-notifications/real-time-notifications.model";

import { CustomerInteractionsAction } from "./customer-interactions.action";
import { CustomerInteractionsConfigService } from "./customer-interactions.config";
import {
	CustomerInteractionMarkRealTimeMessageAsShownPayload,
	CustomerInteractionsAlertAcknowldegementType,
	CustomerInteractionsUnacknowledgedMessageResponse,
} from "./customer-interactions.model";

@Injectable({
	providedIn: "root",
})
export class CustomerInteractionsService {
	constructor(
		private store: Store,
		private httpClient: CoreHttpClient,
		private config: CustomerInteractionsConfigService
	) {}

	markAsShown(message: CustomerInteractionMarkRealTimeMessageAsShownPayload) {
		return this.httpClient.put<string>({
			url: this.config.getMarkAsShownEndpoint(),
			data: {
				messageContent: message.messageContent,
			},
			searchParams: {
				messageId: message.messageId,
			},
		});
	}

	getAllUnacknowledged(): Observable<CustomerInteractionRealTimeMessagePayload[]> {
		return this.httpClient
			.get<CustomerInteractionsUnacknowledgedMessageResponse[]>({
				url: this.config.getUnacknowledgedMessagesEndpoint(),
			})
			.pipe(
				map((messages) =>
					messages.map(
						(message) => JSON.parse(message.messageContent) as CustomerInteractionRealTimeMessagePayload
					)
				)
			);
	}

	showUnacknowledgedMessages(messages: CustomerInteractionRealTimeMessagePayload[]) {
		for (const message of messages) {
			if (this.config.isTriggerEnabled(message.Topic)) {
				this.store.dispatch(CustomerInteractionsAction.openAlert(message));
			}
		}
	}

	markAsAcknowledged(messageId: string, acknowledgedAction: CustomerInteractionsAlertAcknowldegementType) {
		return this.httpClient.put<string>({
			url: this.config.getMarkAsAcknowledgedEndpoint(),
			data: {
				acknowledgedAction,
			},
			searchParams: {
				messageId,
			},
		});
	}
}
